import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import EligibleEnterprise2xUI from './EligibleEnterprise2xUI.js'

class EligibleEnterprise2xSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null
    }
  }

  render() {
    return (
      <EligibleEnterprise2xUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    this.setState({ account: null }, () => {
      this.getAccounts(context)
    })
  }
}

export default withRouter(EligibleEnterprise2xSF)
